var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaintraIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 212,
    viewBox: "0 0 192 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1835_22430)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.006 65.2809L177.112 57.115C176.916 55.8195 177.151 54.4061 177.856 53.1891C179.541 50.2447 183.303 49.2239 186.241 50.9513C189.141 52.6395 190.16 56.3691 188.475 59.3135C186.79 62.258 183.028 63.2787 180.09 61.5513C179.854 61.4335 179.619 61.2765 179.384 61.0802L165.278 69.2461C165.435 69.9528 165.552 70.6595 165.552 71.4054C165.552 76.1165 161.712 79.9247 157.01 79.9247C152.308 79.9247 148.508 76.1165 148.508 71.4054C148.508 66.6943 152.308 62.8469 157.01 62.8469C159.361 62.8469 161.438 63.7891 163.006 65.2809Z",
    fill: "url(#paint0_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.298 156.478C189.298 159.854 186.555 162.602 183.185 162.602C179.815 162.602 177.033 159.854 177.033 156.478C177.033 156.164 177.072 155.889 177.112 155.614L163.006 147.409C161.438 148.94 159.361 149.882 157.01 149.882C152.308 149.882 148.508 146.035 148.508 141.324C148.508 136.613 152.308 132.805 157.01 132.805C161.712 132.805 165.552 136.613 165.552 141.324C165.552 142.07 165.435 142.777 165.278 143.483L179.384 151.649C180.442 150.825 181.735 150.314 183.185 150.314C186.555 150.314 189.298 153.062 189.298 156.478Z",
    fill: "url(#paint1_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.793 47.8084L150.975 37.2869C150.622 34.8921 151.758 32.3795 153.953 31.1232C156.891 29.3958 160.653 30.4165 162.338 33.361C164.023 36.3054 163.004 40.035 160.105 41.7232C157.871 43.0188 155.167 42.7439 153.247 41.2521L135.105 51.7736C135.262 52.441 135.34 53.1869 135.34 53.8936C135.34 58.6047 131.54 62.4521 126.838 62.4521C122.136 62.4521 118.335 58.6047 118.335 53.8936C118.335 49.1825 122.136 45.3743 126.838 45.3743C129.149 45.3743 131.265 46.3165 132.793 47.8084Z",
    fill: "url(#paint2_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.161 176.306C163.161 179.683 160.418 182.431 157.009 182.431C153.6 182.431 150.896 179.683 150.896 176.306C150.896 175.992 150.936 175.717 150.975 175.443L132.793 164.921C131.265 166.413 129.149 167.355 126.838 167.355C122.136 167.355 118.335 163.547 118.335 158.797C118.335 154.046 122.136 150.277 126.838 150.277C131.54 150.277 135.34 154.085 135.34 158.797C135.34 159.543 135.262 160.249 135.105 160.956L153.247 171.477C154.305 170.653 155.598 170.143 157.009 170.143C160.418 170.143 163.161 172.93 163.161 176.306Z",
    fill: "url(#paint3_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.533 125.072C141.218 128.016 140.238 131.746 137.3 133.434C134.361 135.162 130.638 134.141 128.954 131.196C127.269 128.252 128.248 124.522 131.187 122.834C134.126 121.107 137.848 122.127 139.533 125.072Z",
    fill: "url(#paint4_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.3 89.8952C134.361 91.6226 130.638 90.6019 128.954 87.6574C127.269 84.713 128.248 80.9834 131.187 79.256C134.126 77.5678 137.848 78.5886 139.533 81.533C141.218 84.4382 140.238 88.2071 137.3 89.8952Z",
    fill: "url(#paint5_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3778 9.21741C89.6929 6.27297 90.6725 2.50408 93.6113 0.815931C96.5501 -0.872217 100.273 0.148524 101.957 3.05371C103.642 5.99815 102.663 9.76704 99.724 11.4552C96.7852 13.1433 93.0627 12.1619 91.3778 9.21741Z",
    fill: "url(#paint6_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1633 36.4224C88.1633 31.7113 91.9641 27.8639 96.6662 27.8639C98.978 27.8639 101.094 28.8061 102.622 30.3373L120.803 19.8158C120.451 17.3817 121.548 14.9084 123.781 13.6128C126.72 11.9247 130.443 12.9454 132.127 15.8506C133.852 18.795 132.833 22.5639 129.894 24.2521C127.66 25.5476 124.957 25.2728 123.076 23.781L104.895 34.3024C105.091 34.9698 105.169 35.6765 105.169 36.4224C105.169 41.1335 101.368 44.981 96.6662 44.981C91.9641 44.981 88.1633 41.1335 88.1633 36.4224Z",
    fill: "url(#paint7_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.95 193.775C132.95 197.191 130.207 199.939 126.838 199.939C123.468 199.939 120.725 197.191 120.725 193.775C120.725 193.5 120.764 193.186 120.803 192.911L102.622 182.39C101.094 183.921 98.978 184.824 96.6662 184.824C91.9641 184.824 88.1633 181.016 88.1633 176.305C88.1633 171.594 91.9641 167.746 96.6662 167.746C101.368 167.746 105.169 171.594 105.169 176.305C105.169 177.051 105.091 177.757 104.895 178.425L123.076 188.946C124.095 188.122 125.427 187.651 126.838 187.651C130.207 187.651 132.95 190.399 132.95 193.775Z",
    fill: "url(#paint8_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.724 68.1473C96.7852 69.8355 93.0627 68.8148 91.3778 65.9096C89.6929 62.9651 90.6725 59.1962 93.6113 57.5081C96.5501 55.8199 100.273 56.8014 101.957 59.7459C103.642 62.6903 102.663 66.4592 99.724 68.1473Z",
    fill: "url(#paint9_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.957 146.819C103.642 149.764 102.663 153.533 99.724 155.221C96.7852 156.909 93.0627 155.888 91.3778 152.983C89.6929 150.039 90.6725 146.27 93.6113 144.582C96.5501 142.893 100.273 143.914 101.957 146.819Z",
    fill: "url(#paint10_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9975 53.8935C74.9975 58.6046 71.1967 62.452 66.4947 62.452C61.7926 62.452 57.9526 58.6046 57.9526 53.8935C57.9526 49.9676 60.6171 46.6698 64.222 45.6883V24.6454C61.9494 23.7424 60.382 21.5046 60.382 18.9528C60.382 15.5372 63.0857 12.7891 66.4947 12.7891C69.9037 12.7891 72.6073 15.5372 72.6073 18.9528C72.6073 21.5046 71.0008 23.7424 68.7673 24.6454V45.6883C72.333 46.6698 74.9975 49.9676 74.9975 53.8935Z",
    fill: "url(#paint11_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.957 203.511C103.642 206.456 102.663 210.186 99.724 211.913C96.7852 213.601 93.0627 212.58 91.3778 209.636C89.6929 206.731 90.6725 202.962 93.6113 201.274C96.5501 199.586 100.273 200.567 101.957 203.511Z",
    fill: "url(#paint12_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7993 131.196C52.0752 128.252 53.094 124.522 56.0328 122.834C58.9324 121.107 62.694 122.127 64.3789 125.072C66.0638 128.016 65.0842 131.746 62.1454 133.434C59.2067 135.162 55.4842 134.141 53.7993 131.196Z",
    fill: "url(#paint13_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7673 167.041V188.084C69.982 188.594 71.0792 189.458 71.7845 190.714C73.4694 193.659 72.4506 197.388 69.551 199.116C66.6122 200.804 62.8898 199.783 61.1657 196.839C59.4808 193.934 60.4996 190.165 63.4384 188.477C63.6735 188.32 63.9477 188.202 64.1828 188.084V167.041C60.6171 166.06 57.9526 162.723 57.9526 158.797C57.9526 154.085 61.7926 150.277 66.4947 150.277C71.1967 150.277 74.9975 154.085 74.9975 158.797C74.9975 162.723 72.3722 166.06 68.7673 167.041Z",
    fill: "url(#paint14_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7993 87.6574C52.0752 84.713 53.094 80.9834 56.0328 79.256C58.9324 77.5678 62.694 78.5886 64.3789 81.533C66.0638 84.4382 65.0842 88.2071 62.1454 89.8952C59.2067 91.6226 55.4842 90.6019 53.7993 87.6574Z",
    fill: "url(#paint15_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8261 71.4052C44.8261 76.1163 40.9861 79.9245 36.2841 79.9245C31.5821 79.9245 27.7812 76.1163 27.7812 71.4052C27.7812 67.4793 30.4066 64.1815 34.0115 63.1608V42.1178C31.778 41.2149 30.1715 39.0163 30.1715 36.4252C30.1715 33.0489 32.9143 30.3008 36.2841 30.3008C39.6539 30.3008 42.3968 33.0489 42.3968 36.4252C42.3968 39.0163 40.8294 41.2149 38.5959 42.1178V63.1608C42.1617 64.1815 44.8261 67.4793 44.8261 71.4052Z",
    fill: "url(#paint16_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1498 62.3739C13.5257 62.3739 16.2624 59.6319 16.2624 56.2494C16.2624 52.867 13.5257 50.125 10.1498 50.125C6.77384 50.125 4.03711 52.867 4.03711 56.2494C4.03711 59.6319 6.77384 62.3739 10.1498 62.3739Z",
    fill: "url(#paint17_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5568 149.568V170.611C39.8106 171.082 40.8686 171.985 41.6131 173.242C43.298 176.147 42.2792 179.916 39.3404 181.604C36.4408 183.292 32.6792 182.311 30.9943 179.366C29.3094 176.422 30.3282 172.692 33.2278 170.965C33.5021 170.847 33.7372 170.69 34.0115 170.611V149.568C30.4066 148.548 27.7812 145.25 27.7812 141.324C27.7812 136.613 31.5821 132.805 36.2841 132.805C40.9861 132.805 44.8261 136.613 44.8261 141.324C44.8261 145.25 42.1617 148.548 38.5568 149.568Z",
    fill: "url(#paint18_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4788 159.54C13.7547 162.485 10.0323 163.466 7.09349 161.778C4.15471 160.09 3.17512 156.321 4.86002 153.416C6.54492 150.471 10.3065 149.451 13.2061 151.139C16.1449 152.866 17.1637 156.596 15.4788 159.54Z",
    fill: "url(#paint19_radial_1835_22430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8262 106.347C44.8262 111.097 40.9862 114.905 36.2841 114.905C33.9723 114.905 31.8564 113.963 30.3282 112.471L12.1862 122.993C12.3429 124.288 12.1862 125.662 11.4025 126.919C9.7176 129.863 5.99515 130.844 3.05638 129.156C0.117604 127.468 -0.861988 123.699 0.82291 120.794C2.50781 117.85 6.23026 116.829 9.16903 118.517C9.44332 118.674 9.67842 118.831 9.91352 119.027L28.0556 108.506C27.8988 107.799 27.7813 107.093 27.7813 106.347C27.7813 105.64 27.8988 104.894 28.0556 104.227L9.87434 93.7052C7.99352 95.1971 5.28985 95.4719 3.05638 94.1763C0.117604 92.4882 -0.861988 88.7585 0.82291 85.8141C2.50781 82.8697 6.23026 81.8489 9.16903 83.5763C11.4025 84.8326 12.4996 87.3452 12.1862 89.74L30.3282 100.262C31.8564 98.7697 33.9723 97.8274 36.2841 97.8274C40.9862 97.8274 44.8262 101.636 44.8262 106.347Z",
    fill: "url(#paint20_radial_1835_22430)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4904 113.727) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4904 113.725) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.725) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.727) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.726) scale(92.5911 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.726) scale(92.5911 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4905 113.726) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.724) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.725) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4905 1.95625) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4905 1.95271) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.725) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4905 113.726) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4891 113.726) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.727) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4891 113.726) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.727) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4902 113.725) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.725) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4902 113.725) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1835_22430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.489 113.727) scale(92.591 92.7696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1835_22430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 212,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaintraIcon);
export default __webpack_public_path__ + "static/media/Caintra_Icon.51d583f41ad70171bc7f60dc67e32733.svg";
export { ForwardRef as ReactComponent };